import React from 'react'

import { parseUrlParameters } from '../../util'

import CloseIcon from '../../assets/icons/close-icon'


import './youtube-player.scss'


class YoutubePlayer extends React.Component {
  constructor(props) {
    super(props)

    this.onClose = this.onClose.bind(this)
    this.state = {
      play: false
    }
  }

  getVideoUrl(url) {
    const params = parseUrlParameters(url)

    if ('v' in params) {
      const videoId = params.v

      return `https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&controls=1&fs=1`
    } else {
      return null
    }
  }

  onClose() {
    this.props.closeVideo()
  }

  render() {
    const { url, height, play, localization } = this.props
    const embedUrl = this.getVideoUrl(url)

    if (play && embedUrl) {
      return (
        <div className="video-container">
          <iframe width="100%" height={ height } src={ embedUrl } allowFullScreen>
          </iframe>
          <button className="btn primary close" onClick={ this.onClose }>
            <span className="description">{ localization('global.close') }</span>
            <CloseIcon className="close-icon"/>
          </button>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default YoutubePlayer


// WEBPACK FOOTER //
// ./src/components/YoutubePlayer/youtube-player.js